import { labelingSlice } from '../LabelingSlice'
import useSliceWrapper from './useSliceWrapper'

const useGetMethodsAndData = () => useSliceWrapper('labeling', labelingSlice)

export const useLabelingSlice = (): ReturnType<typeof useGetMethodsAndData> =>
  useGetMethodsAndData()

export default useLabelingSlice
